<template>
<span>
    <chand-arzi-details></chand-arzi-details>
    <page-footer></page-footer>
</span>
</template>
<script>
import ChandArziDetails from '@/components/moduls/ChandArziDetails';
import PageFooter from '@/components/PageFooter';
export default {
    name :'chandarzi',
    components:{
        ChandArziDetails,
        PageFooter
    }

    
};
</script>


